<template>
  <v-card class="pa-2 mb-2" flat style="border-radius: 10px;">
    <v-layout row>
      <v-avatar size="45" class="mt-1 ml-1">
        <v-img
          :src="user.avatar"
        />
      </v-avatar>
      <span class="ml-3 mt-1 pt-2" style="font-size: 17px;">{{ user.name }}</span>
      <v-layout justify-end row>
        <v-btn fab small color="success" outline @click="acceptUser" :loading="loading">
          <v-icon>fa fa-check</v-icon>
        </v-btn>
        <v-btn fab small color="error" outline @click="rejectUser" :loading="loading2">
          <v-icon>fa fa-times</v-icon>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import firebase from 'firebase'
export default {
  data() {
    return{
      loading: false,
      loading2: false
    };
  },
  props: {
    user: Object,
    postId: String
  },

  methods: {
    acceptUser(){
      this.loading = true;
      const db = firebase.firestore();
      var vm = this;
      var newRequests = [], newAccepted = [], newRejected = [], deleteIndex, userRequested = [], userAccepted = [], deleteUserIndex, full = false;
      db.collection('posts').doc(vm.postId).get()
      .then(function(doc){
        newRequests = doc.data().requests;
        newAccepted = doc.data().accepted;
        newRejected = doc.data().rejected;
        if(newAccepted.length+1 == doc.data().accept_limit){
          full = true;
        }
        newRequests.forEach(function(item, index){
          if(item.uid == vm.user.uid){
            deleteIndex = index;
          }
        });
        newRequests.splice(deleteIndex,1);
        if (full){
          newRequests.forEach(function(pendingUser){
            let pendingUserRequested = [], pendingUserRejected = [], pendingIndex;
            newRejected.push(pendingUser.uid);
            db.collection('users').doc(pendingUser.uid).get()
            .then(function(pendingUserDoc){
              pendingUserRequested = pendingUserDoc.data().requested;
              pendingUserRejected = pendingUserDoc.data().rejected;
              pendingIndex = pendingUserRequested.indexOf(vm.postId);
              pendingUserRequested.splice(pendingIndex,1);
              pendingUserRejected.push(vm.postId);
              db.collection('users').doc(pendingUser.uid).update({
                requested: pendingUserRequested,
                rejected: pendingUserRejected
              })
            })
          })
        }
        db.collection('users').doc(vm.user.uid).get()
        .then(function(userDoc){
          newAccepted.push({
            uid: userDoc.id,
            name: userDoc.data().name,
            avatar: userDoc.data().avatar,
            email: userDoc.data().email,
            contact: userDoc.data().contact
          });
          userRequested = userDoc.data().requested;
          userAccepted = userDoc.data().accepted;
          userRequested.forEach(function(item, index){
            if(item == vm.postId){
              deleteUserIndex = index;
            }
          });
          userRequested.splice(deleteUserIndex,1);
          userAccepted.push(vm.postId);
          db.collection('posts').doc(vm.postId).update({
            requests: newRequests,
            accepted: newAccepted,
            rejected: newRejected,
            post_closed: full,
          })
          .then(function(){
            db.collection('users').doc(vm.user.uid).update({
              requested: userRequested,
              accepted: userAccepted
            })
          })
        });
      });
    },

    rejectUser(){
      this.loading2 = true;
      const db = firebase.firestore();
      var vm = this;
      var newRequests = [], newRejected = [], deleteIndex, userRequested = [], userRejected = [], deleteUserIndex;
      db.collection('posts').doc(vm.postId).get()
      .then(function(doc){
        newRequests = doc.data().requests;
        newRejected = doc.data().rejected;
        newRequests.forEach(function(item, index){
          if(item.uid == vm.user.uid){
            deleteIndex = index;
          }
        });
        newRequests.splice(deleteIndex,1);
        db.collection('users').doc(vm.user.uid).get()
        .then(function(userDoc){
          newRejected.push(vm.user.uid)
          userRequested = userDoc.data().requested;
          userRejected = userDoc.data().rejected;
          userRequested.forEach(function(item, index){
            if(item == vm.postId){
              deleteUserIndex = index;
            }
          });
          userRequested.splice(deleteUserIndex,1);
          userRejected.push(vm.postId);
          db.collection('posts').doc(vm.postId).update({
            requests: newRequests,
            rejected: newRejected
          })
          .then(function(){
            db.collection('users').doc(vm.user.uid).update({
              requested: userRequested,
              rejected: userRejected
            })
            .then(function(){
              this.loading=false;
            })
          })
        });
      });
    },
  }
}
</script>